export { default } from './RichTextInputArea';
